import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { Swipe } from '../types';


interface UserSwipesState {
  swipes: {
    [ userId: string ]: Swipe[]
  },
  loading: boolean;
}

const initialState: UserSwipesState = {
  swipes: {},
  loading: false,
}



const service = createSlice({
  name: 'userSwipes',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<{ isLoading: boolean, userId: string }>): UserSwipesState {
      let newState = { ...state, loading: action.payload.isLoading };

      if (!action.payload.isLoading) {
        newState = {
          ...newState,
          swipes: {
            ...newState.swipes,
            [action.payload.userId]: []
          },
        }
      }

      return newState;
    },
    setSwipes(state, action: PayloadAction<{userId: string, swipes: Swipe[]}>): UserSwipesState {
      return { 
        ...state, 
        swipes: {
          ...state.swipes,
          [action.payload.userId]: action.payload.swipes,
        }, 
        loading: false,
      }
    },

  }
});



const loadSwipes = (userId: string): AppThunk => async (dispatch, getState) => {
  if (getState().userSwipes.swipes[userId]) {
    return;
  }
  
  dispatch(service.actions.setLoading({
    userId,
    isLoading: true,
  }));

  const queryFromMe = firestore.collection('swipes')
    .where('userId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const queryToMe = firestore.collection('swipes')
    .where('targetUserId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const fromMe = await firestoreQuery<Swipe>(queryFromMe);
  const toMe = await firestoreQuery<Swipe>(queryToMe);

  dispatch(service.actions.setSwipes({
    userId,
    swipes: [
      ...fromMe.list,
      ...toMe.list,
    ]
  }));
}



export const actions = {
  loadSwipes,
}

export default service.reducer;